import { screenXsMax, Text, titleLarge, screenMdMax, titleMedium, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
export const Heading = styled(Text).attrs({
    variant: 'titleLarge',
    className: 'heading',
}) `
  display: block;
  @media (max-width: ${screenMdMax}) {
    ${titleMedium}
  }
  @media (max-width: ${screenXsMax}) {
    ${titleLarge}
  }
`;
